import { useEffect, useState } from 'react'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { ROLL_API, addRollByStock, getNextUpc } from '../../api/rollApi'
import { toast } from 'react-toastify'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import useFirstRender from '../../hooks/FirstRender'
import ProductPicker from '../../components/product/ProductPicker'
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi'
import LocationPicker from '../../components/location/LocationPicker'
import Button from '../../components/Button'

const StockAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const closeTab = useCloseTab()
    const [newEntity, setNewEntity] = useState({
        upc: "",
        product: null,
        quantity: "",
        restQuantity: "",
        location: null,
        boilerCode: "",
        unitCost: "",
        date: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${ROLL_API}`, true)

    const onClickSubmit = () => {
        const body = {
            upc: newEntity.upc,
            productId: newEntity.product?.id,
            quantity: newEntity.quantity,
            restQuantity: newEntity.restQuantity,
            locationId: newEntity.location?.id,
            boilerCode: newEntity.boilerCode,
            unitCost: newEntity.unitCost,
            date: newEntity.date
        }
        addRollByStock(body)
            .then(res => {
                closeTab()
                toast.success('Stok kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    const [productPage, setProductPage] = useState({
        content: []
    });
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }
    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }
    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const [locationPage, setLocationPage] = useState({
        content: []
    });

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])
    const [locationQuery, setLocationQuery] = useState('')
    const [searchTimerLocation, setSearchTimerLocation] = useState();
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)
    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }
    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }
    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }
    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])

    useEffect(() => {
        loadProducts({ size: 20 })
        loadLocations({ size: 20 })
    }, [])

    const onClickGetNextUpc = () => {
        getNextUpc()
            .then(res => {
                setNewEntity(prevState => ({ ...prevState, upc: res.data }))
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Stok</label>
                <Input
                    className='mb-0'
                    label='Barkod'
                    name='upc'
                    type='number'
                    placeholder='Barkod no girin...'
                    error={errors?.upc}
                    value={newEntity.upc}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <label className='text-xs mb-3 inline-block text-blue-600 border-b-2 cursor-pointer hover:text-blue-900' onClick={onClickGetNextUpc} > Barkod numarası al </label>
                <ProductPicker
                    label='Ürün'
                    pendingApiCall={pendingApiCallProduct}
                    state={newEntity.product}
                    setState={(value) => setNewEntity(prevState => ({ ...prevState, product: value }))}
                    query={productQuery}
                    setQuery={setProductQuery}
                    error={errors?.productId}
                    page={productPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                    onClickClear={() => setNewEntity(prevState => ({ ...prevState, product: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreProduct()}
                />
                <Input
                    label='Miktar(m)'
                    name='quantity'
                    type='number'
                    placeholder='Miktar girin...'
                    error={errors?.quantity}
                    value={newEntity.quantity}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Kalan(m)'
                    name='restQuantity'
                    type='number'
                    placeholder='Kalan miktar girin...'
                    error={errors?.restQuantity}
                    value={newEntity.restQuantity}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <LocationPicker
                    label='Lokasyon'
                    pendingApiCall={pendingApiCallLocation}
                    state={newEntity.location}
                    setState={(value) => setNewEntity(prevState => ({ ...prevState, location: value }))}
                    query={locationQuery}
                    setQuery={setLocationQuery}
                    error={errors?.locationId}
                    page={locationPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                    onClickClear={() => setNewEntity(prevState => ({ ...prevState, location: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreLocation()}
                />
                <Input
                    label='Kazan No'
                    name='boilerCode'
                    placeholder='Kazan no girin...'
                    error={errors?.boilerCode}
                    value={newEntity.boilerCode}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Birim Maliyet (USD/m)'
                    name='unitCost'
                    type='number'
                    placeholder='Birim maliyet girin...'
                    error={errors?.unitCost}
                    value={newEntity.unitCost}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Tarih'
                    type='date'
                    name='date'
                    placeholder='Birim maliyet girin...'
                    error={errors?.date}
                    value={newEntity.date}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
            </div>
            <div className='flex justify-center'>
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onClickSubmit}
                />
            </div>

        </div>
    )
}

export default StockAddPage